import { render, staticRenderFns } from "./tradecard.vue?vue&type=template&id=65bb2dbf&scoped=true"
import script from "./tradecard.vue?vue&type=script&lang=js"
export * from "./tradecard.vue?vue&type=script&lang=js"
import style0 from "./tradecard.vue?vue&type=style&index=0&id=65bb2dbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb2dbf",
  null
  
)

export default component.exports